import React, { useRef, useEffect } from "react";
import Viewer from "./scene/Viewer";
import ExperienceUI from "./experience-ui/ExperienceUI";
import firebase from "firebase";
import { useHistory, useParams } from 'react-router-dom';

const Studio = (props) => {
  const {phoneNumber}=useParams();
  const phoneno = useParams(phoneNumber);
  const history = useHistory();
  const currentUser = firebase.auth().currentUser;

  useEffect(() => {
    if (!currentUser) {
      history.push("/signin", { from: `/experience/${phoneNumber}` });
    }
  }, [currentUser])

  const [currentLocation, setCurrentLocation] = React.useState("Home");
  const [minimapData, setMinimapData] = React.useState(null);

  const viewerRef = useRef();

  const goToHome = () => viewerRef.current.goToHome();
  const goToFirstFloor = () => viewerRef.current.goToFirstFloor();
  const moveToWayPoint = (waypoint) =>
    viewerRef.current.moveToWayPoint(waypoint);
  const logLeaderboard = (areaName, mediaSpotName, points) => viewerRef.current.logLeaderBoard(areaName, mediaSpotName, points)

  return (
    <div>
      <Viewer setMinimapData={setMinimapData} ref={viewerRef} phoneno={phoneno} />
      <ExperienceUI
        goToHome={goToHome}
        goToFirstFloor={goToFirstFloor}
        moveToWayPoint={moveToWayPoint}
        setCurrentLocation={setCurrentLocation}
        minimapData={minimapData}
        logLeaderBoard={logLeaderboard}
      />
    </div>
  );
};

export default Studio;
